import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { PageOne, PageTwo } from './components';
;
export const DocumentSix = memo(({ pharmacy, traderInfo, user, }) => (_jsxs(_Fragment, { children: [_jsx(PageOne, { pharmacy: pharmacy, traderInfo: traderInfo, user: user }), _jsx(PageTwo, { pharmacy: pharmacy, traderInfo: traderInfo })] })));
